import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationStatus = ({ role }) => {
  const getVerificationSteps = () => {
    const steps = {
      contractor: [
        {
          title: 'Profiel Controle',
          description: 'Uw basisgegevens zijn gecontroleerd',
          status: 'completed',
          icon: 'CheckCircle'
        },
        {
          title: 'Vaardigheden Verificatie',
          description: 'Uw vaardigheden en certificeringen zijn geregistreerd',
          status: 'completed',
          icon: 'CheckCircle'
        },
        {
          title: 'Account Activatie',
          description: 'Uw account wordt geactiveerd na voltooiing',
          status: 'pending',
          icon: 'Clock'
        }
      ],
      client: [
        {
          title: 'Bedrijfsgegevens',
          description: 'Uw bedrijfsinformatie is geregistreerd',
          status: 'completed',
          icon: 'CheckCircle'
        },
        {
          title: 'Verificatie',
          description: 'Bedrijfsverificatie kan 1-2 werkdagen duren',
          status: 'pending',
          icon: 'Clock'
        },
        {
          title: 'Account Activatie',
          description: 'U krijgt direct toegang tot het platform',
          status: 'pending',
          icon: 'Clock'
        }
      ],
      affiliate: [
        {
          title: 'Netwerkgegevens',
          description: 'Uw netwerkgegevens zijn geregistreerd',
          status: 'completed',
          icon: 'CheckCircle'
        },
        {
          title: 'Netwerk Validatie',
          description: 'Uw verwijzingsmogelijkheden zijn gevalideerd',
          status: 'completed',
          icon: 'CheckCircle'
        },
        {
          title: 'Commissie Setup',
          description: 'Uw commissiestructuur wordt ingesteld',
          status: 'pending',
          icon: 'Clock'
        }
      ]
    };

    return steps?.[role] || [];
  };

  const steps = getVerificationSteps();

  const getStatusColor = (status) => {
    return status === 'completed' ? 'text-success' : 'text-warning';
  };

  const getStatusBg = (status) => {
    return status === 'completed' ? 'bg-success/10' : 'bg-warning/10';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
        <Icon name="Shield" size={24} />
        Verificatie Status
      </h2>
      <p className="text-sm text-muted-foreground">
        Hieronder ziet u de status van uw profielverificatie
      </p>

      <div className="space-y-3 mt-4">
        {steps?.map((step, index) => (
          <div
            key={index}
            className={`flex items-start gap-3 p-4 rounded-lg border ${
              step?.status === 'completed' ? 'border-success/20 bg-success/5' : 'border-warning/20 bg-warning/5'
            }`}
          >
            <div className={`flex-shrink-0 w-10 h-10 rounded-full ${getStatusBg(step?.status)} flex items-center justify-center`}>
              <Icon name={step?.icon} size={20} className={getStatusColor(step?.status)} />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-foreground">{step?.title}</h3>
              <p className="text-sm text-muted-foreground mt-1">{step?.description}</p>
            </div>
            {step?.status === 'completed' && (
              <div className="flex-shrink-0">
                <span className="px-2 py-1 bg-success/10 text-success text-xs rounded-md font-medium">
                  Voltooid
                </span>
              </div>
            )}
            {step?.status === 'pending' && (
              <div className="flex-shrink-0">
                <span className="px-2 py-1 bg-warning/10 text-warning text-xs rounded-md font-medium">
                  In behandeling
                </span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground">
              <strong>Let op:</strong> U krijgt direct toegang tot het platform na voltooiing. Sommige functies kunnen beperkt zijn totdat alle verificaties zijn afgerond.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationStatus;